export default (applicationService) => {
  return {
    namespaced: true,
    state: {
      uniqueSiteCode: null,
      lineIdUsageTypes: [],
      lineIdLicencePeriods: [],
      lineIdSpectrumService: [],
      autoApproval: false,
      intervals: [],
      specialRequestTime: 180,
      lineIdImportWhitelistEnabled: true,
      sizePerPageLineId: 1000,
      sizePerPageBarcode: 100,
      addressApiUrl: null,
      captchaTypeFr: null,
      captchaTypeEn: null
    },

    getters: {
      getUniqueSiteCode(state) {
        return state.uniqueSiteCode;
      },

      getLineIdUsageTypes(state) {
        return state.lineIdUsageTypes;
      },

      getLineIdLicencePeriods(state) {
        return state.lineIdLicencePeriods;
      },

      getLineIdSpectrumService(state) {
        return state.lineIdSpectrumService;
      },

      isAutoApproval(state) {
        return state.autoApproval;
      },

      getIntervals(state){
        return state.intervals
      },

      getSpecialRequestTime(state) {
        return state.specialRequestTime;
      },

      getLineIdImportWhitelistEnabled(state) {
        return state.lineIdImportWhitelistEnabled;
      },

      getSizePerPageLineId(state){
        console.log('Get default value ', state.sizePerPageLineId);
        return state.sizePerPageLineId;
      },

      getSizePerPageBarcode(state){
        console.log('Get default value ', state.sizePerPageBarcode);
        return state.sizePerPageBarcode;
      },

      getAddressApiUrl(state) {
        return state.addressApiUrl;
      },

      getCaptchaTypeFr(state) {
        return state.captchaTypeFr
      },

      getCaptchaTypeEn(state) {
        return state.captchaTypeEn
      }
    },
    mutations: {
      setSiteCode(state, siteCode) {
        state.uniqueSiteCode = siteCode;
      },
      setLineIdUsageTypes(state, usageTypes) {
        state.lineIdUsageTypes = usageTypes;
      },
      setLineIdLicencePeriods(state, licencePeriods) {
        state.lineIdLicencePeriods = licencePeriods;
      },
      setLineIdSpectrumService(state, spectrumService){
        state.lineIdSpectrumService = spectrumService;
      },
      setAutoApproval(state, autoApproval) {
        state.autoApproval = autoApproval;
      },
      setIntervals(state, intervals){
        state.intervals = intervals;
      },
      setSpecialRequestTime(state, specialRequestTime) {
        state.specialRequestTime = specialRequestTime;
      },
      setLineIdImportWhitelistEnabled(state, lineIdImportWhitelistEnabled) {
        state.lineIdImportWhitelistEnabled = lineIdImportWhitelistEnabled;
      },
      setSizePerPageLineId(state, sizePerPageLineId) {
        state.sizePerPageLineId = sizePerPageLineId;
        console.log('SetSizePerPageLineId ', state.sizePerPageLineId);
      },
      setSizePerPageBarcode(state, sizePerPageBarcode) {
        state.sizePerPageBarcode = sizePerPageBarcode;
        console.log('SetSizePerPageBarcode ', state.sizePerPageBarcode);
      },
      setAddressApiUrl(state, addressApiUrl) {
        state.addressApiUrl = addressApiUrl;
      },
      setCaptchaTypeFr(state, captchaTypeFr) {
        state.captchaTypeFr = captchaTypeFr;
      },
      setCaptchaTypeEn(state, captchaTypeEn) {
        state.captchaTypeEn = captchaTypeEn;
      }
    },
    actions: {
      async init(context) {
        const configuration = await applicationService.getConfiguration();
        context.commit('setSiteCode', configuration.uniqueSiteCode);
        context.commit('setLineIdUsageTypes', configuration.usageTypes);
        context.commit('setLineIdLicencePeriods', configuration.licencePeriods);
        context.commit('setLineIdSpectrumService', configuration.spectrumServices);
        context.commit('setAutoApproval', configuration.autoApproval);
        context.commit('setIntervals', configuration.intervals.sort((i1,i2) => {return i1.time -i2.time}));
        context.commit('setSpecialRequestTime', configuration.specialRequestTime);
        context.commit('setLineIdImportWhitelistEnabled', configuration.lineIdImportWhitelistEnabled);
        context.commit('setSizePerPageLineId', configuration.sizePerPageLineId);
        context.commit('setSizePerPageBarcode', configuration.sizePerPageBarcode);
        context.commit('setAddressApiUrl', configuration.addressApiUrl);
        context.commit('setCaptchaTypeFr', configuration.captchaTypeFr);
        context.commit('setCaptchaTypeEn', configuration.captchaTypeEn);
      }
    }
  }
}
